import CloudWatchLogs from 'aws-sdk/clients/cloudwatchlogs';
import dayjs from 'dayjs';

import dayjs_utc from 'dayjs/plugin/utc';
dayjs.extend(dayjs_utc);

class AWSCloudWatchLog {
  constructor(params) {
    this.AWSLogGroupName = params.logGroupName;
    this.AWSLogStreamName = params.logStreamName;

    this.AWSCloudWatch = this.init(params);
  }

  init(params) {
    const { region, accessKeyId, secretAccessKey } = params;

    return new CloudWatchLogs({ region, accessKeyId, secretAccessKey });
  }

  describeLogStream(logGroupName, logStreamNamePrefix) {
    const params = {
      logGroupName,
      logStreamNamePrefix,
    };

    return new Promise((resolve, reject) => {
      this.AWSCloudWatch.describeLogStreams(params, (err, data) => {
        if (err) return reject(err);

        const { logStreams: [logStreamInfo] = [] } = data;
        resolve(logStreamInfo);
      });
    });
  }

  createLogStream(logGroupName, logStreamName) {
    const params = {
      logGroupName,
      logStreamName,
    };

    return new Promise((resolve, reject) => {
      this.AWSCloudWatch.createLogStream(params, err => {
        err ? reject(err) : resolve();
      });
    });
  }

  putLogEvent(logObject, logGroupName, logStreamName, sequenceToken) {
    const logBody = {
      logEvents: [
        {
          message: JSON.stringify(logObject),
          timestamp: dayjs(dayjs.utc().format('YYYY-MM-DDTHH:mm:ss')).valueOf(), // Returns the number of milliseconds of UTC Time since the Unix Epoch
        },
      ],
      logGroupName,
      logStreamName,
      sequenceToken,
    };

    return new Promise((resolve, reject) => {
      this.AWSCloudWatch.putLogEvents(logBody, (err, data) => {
        err ? reject(err) : resolve(data);
      });
    });
  }

  log(logObject) {
    const logGroupName = this.AWSLogGroupName;
    const logStreamName = this.AWSLogStreamName;

    function displayLogObject() {
      // If AWS CloudWatch API is unavailable
      // the logged object should be shown in the console
      // to avoid complete loss of error info
      console.log(JSON.stringify(logObject));
    }

    this.describeLogStream(logGroupName, logStreamName)
      .then(logStreamInfo => {
        // Check if log stream exists
        if (!logStreamInfo) {
          this.createLogStream(logGroupName, logStreamName)
            .then(() => {
              this.putLogEvent(logObject, logGroupName, logStreamName, null).catch(displayLogObject);
            })
            .catch(displayLogObject);
          return;
        }

        this.putLogEvent(logObject, logGroupName, logStreamName, logStreamInfo.uploadSequenceToken).catch(err => {
          // If the sequence token is invalid there may be another instance
          // that had put an event less than a second ago (AWS limitation),
          // in such a case, an event must be put in the queue
          // and a new sequence token should be requested to put a log event
          if (err.code === 'InvalidSequenceTokenException') {
            setTimeout(this.log.bind(this, logObject), 1000);
          }
        });
      })
      .catch(displayLogObject);
  }
}

export default AWSCloudWatchLog;
